import {
  ApiCartReplaceEmailInCartFailedAction,
  ApiCartReplaceEmailInCartSucceededAction,
  apiCartReplaceEmailInCartFailedType,
  apiCartReplaceEmailInCartRequested,
  apiCartReplaceEmailInCartSucceededType
} from '../../api/cart/replaceEmailInCartApi';
import {
  ChangeCurrentCartEmailRequestedAction,
  changeCurrentCartEmailFailed,
  changeCurrentCartEmailSucceeded
} from '../../carts/cartsSlice';
import { put, race, take } from 'typed-redux-saga';
import { CustomOrderType } from '../../carts/CustomOrderType';
import { ReplaceEmailInCartResult } from '../../../graphql/cart/replaceEmailInCart';
import convertCartToStateCart from '../../../converters/convertCartToStateCart';
import generateActionId from '../../../generateActionId';

function* changeCurrentCartEmailSaga({
  payload: { actionId: requestedActionId, customOrderType, email }
}: ChangeCurrentCartEmailRequestedAction): Generator {
  const actionId: number = generateActionId();
  yield* put(
    apiCartReplaceEmailInCartRequested({
      actionId,
      customOrderType,
      email,
      parentActionId: requestedActionId
    })
  );

  yield* actionsLoop(actionId, requestedActionId, customOrderType);
}

function* actionsLoop(
  actionId: number,
  requestedActionId: number,
  customOrderType: CustomOrderType
): Generator {
  let isSameActionId: boolean = false;
  do {
    const { succeeded, failed } = yield* race({
      succeeded: take<ApiCartReplaceEmailInCartSucceededAction>(
        apiCartReplaceEmailInCartSucceededType
      ),
      failed: take<ApiCartReplaceEmailInCartFailedAction>(apiCartReplaceEmailInCartFailedType)
    });

    isSameActionId =
      succeeded?.payload.requestedActionId === actionId ||
      failed?.payload.requestedActionId === actionId;

    if (isSameActionId) {
      if (succeeded !== undefined) {
        const { cart, error }: ReplaceEmailInCartResult = succeeded.payload.result;
        if (cart === null || error !== null) {
          yield* put(
            changeCurrentCartEmailFailed({
              requestedActionId
            })
          );
        } else {
          yield* put(
            changeCurrentCartEmailSucceeded({
              cart: convertCartToStateCart(cart),
              customOrderType,
              requestedActionId
            })
          );
        }
      } else if (failed !== undefined) {
        yield* put(
          changeCurrentCartEmailFailed({
            requestedActionId
          })
        );
      }
    }
  } while (!isSameActionId);
}

export default changeCurrentCartEmailSaga;
